<div class="container-fluid">
  <mat-toolbar class="toolbar" role="navigation" id="navigation_toolbar">
    <mat-toolbar-row>
      <ng-container [ngTemplateOutlet]="navCompany"> </ng-container>

      <!-- header-menü, sichtbar wenn screen breit genug ist -->
      <ul class="display-contents hide-sm">
        <li>
          <a
            matButton
            class="tab-aufgaben"
            [routerLink]="getRouterLinkUrlForCurrentTenant('aufgaben')"
            routerLinkActive="active-link"
            data-testid="navigationAufgabenLink_header"
            [matBadge]="getBadgeValue(meineAufgabenCount$ | async)"
            [matBadgeHidden]="(meineAufgabenCount$ | async) === 0"
            matBadgeSize="small"
            [attr.aria-label]="
              'Texte.Navigation.ButtonMitBadge.AufgabenButtonMitAnzahl'
                | translate
                  : {
                      seitentitel: 'Texte.Navigation.Aufgaben' | translate,
                      aufgabenzahl: meineAufgabenCount$ | async,
                    }
            "
          >
            {{ 'Texte.Navigation.Aufgaben' | translate }}
          </a>
        </li>

        <li aria-hidden="true">
          <mat-divider [vertical]="true" aria-hidden="true"></mat-divider>
        </li>

        <li>
          <a
            matButton
            class="tab-workflows"
            [routerLink]="getRouterLinkUrlForCurrentTenant('workflows')"
            routerLinkActive="active-link"
            data-testid="navigationWorkflowsLink_header"
            [matBadge]="getBadgeValue(workflowCount$ | async)"
            [matBadgeHidden]="(workflowCount$ | async) === 0"
            matBadgeSize="small"
            [attr.aria-label]="
              'Texte.Navigation.ButtonMitBadge.WorkflowButtonMitAnzahl'
                | translate
                  : {
                      seitentitel: 'Texte.Navigation.Workflows' | translate,
                      workflowzahl: workflowCount$ | async,
                    }
            "
          >
            {{ 'Texte.Navigation.Workflows' | translate }}
          </a>
        </li>

        @if (tenantService.currentTenant?.id !== 0) {
          <li aria-hidden="true">
            <mat-divider [vertical]="true" aria-hidden="true"></mat-divider>
          </li>
        }

        @if (tenantService.currentTenant?.id !== 0) {
          <li>
            <a
              matButton
              class="tab-zusammenarbeit"
              [routerLink]="getRouterLinkUrlForCurrentTenant('zusammenarbeit')"
              routerLinkActive="active-link"
              data-testid="navigationZusammenarbeitLink_header"
              matBadge="!"
              [matBadgeHidden]="
                (hasVertreter() | async) === true || (hasVertreter() | async) === undefined
              "
              matBadgeSize="small"
              [attr.aria-label]="getZusammenarbeitAriaLabel() | async"
            >
              {{ 'Texte.Navigation.Zusammenarbeit' | translate }}
            </a>
          </li>
        }

        <li aria-hidden="true">
          @if (
            (currentUser$ | async)?.isWorkflowErsteller && tenantService.currentTenant?.id !== 0
          ) {
            <mat-divider [vertical]="true" aria-hidden="true"></mat-divider>
          }
        </li>

        @if ((currentUser$ | async)?.isWorkflowErsteller && tenantService.currentTenant?.id !== 0) {
          <li>
            <a
              matButton
              class="tab-vorlagen"
              data-testid="navigationVorlagenLink_header"
              [routerLink]="getRouterLinkUrlForCurrentTenant('vorlagen/persoenlich')"
              routerLinkActive="active-link"
              [attr.aria-label]="
                'Texte.Navigation.NavigiereZu'
                  | translate: { seitentitel: 'Texte.Navigation.MeineVorlagen' | translate }
              "
            >
              {{ 'Texte.Navigation.MeineVorlagen' | translate }}
            </a>
          </li>
        }

        <li aria-hidden="true">
          @if (
            (currentUser$ | async)?.isWorkflowErsteller && tenantService.currentTenant?.id !== 0
          ) {
            <mat-divider [vertical]="true" aria-hidden="true"></mat-divider>
          }
        </li>

        @if ((currentUser$ | async)?.isWorkflowErsteller && tenantService.currentTenant?.id !== 0) {
          <li>
            <a
              matButton="filled"
              [routerLink]="getRouterLinkUrlForCurrentTenant('neu')"
              data-testid="navigationNeuerWorkflowButton_header"
              [attr.aria-label]="
                'Texte.Navigation.NavigiereZu'
                  | translate: { seitentitel: 'Texte.Navigation.NeuerWorkflow' | translate }
              "
            >
              <mat-icon class="topnav-button" fontSet="fa" fontIcon="fa-plus"></mat-icon>
              {{ 'Texte.Navigation.NeuerWorkflow' | translate }}
            </a>
          </li>
        }
      </ul>

      <span class="spacer hide-sm" aria-hidden="true"></span>

      <ul class="display-contents right hide-sm">
        @if (
          (currentUser$ | async)?.isWorkflowAdministrator && tenantService.currentTenant?.id > 0
        ) {
          <li>
            <button
              matIconButton
              [matMenuTriggerFor]="grundeinstellungenmenu"
              aria-label="Example icon-button with a menu"
            >
              <mat-icon fontSet="fa" fontIcon="fa-cogs"></mat-icon>
            </button>
          </li>
        }

        @if ((currentUser$ | async)?.isSystemAdmin && tenantService.currentTenant?.id === 0) {
          <li>
            <a
              matIconButton
              class="tab-grundeinstellung"
              [routerLink]="getRouterLinkUrlForCurrentTenant('management')"
              routerLinkActive="active-link"
              data-testid="navigationGrundeinstellungenLink_header"
              [attr.aria-label]="
                'Texte.Navigation.NavigiereZu' | translate: { seitentitel: 'Management Tool' }
              "
              title="Management Tool"
            >
              <mat-icon fontSet="fa" fontIcon="fa-cogs"></mat-icon>
            </a>
          </li>
        }
        <li>
          <button
            class="tab-benutzereinstellung"
            matIconButton
            [matMenuTriggerFor]="benutzerMenu"
            [title]="'Texte.Navigation.Benutzeraktionen' | translate"
            [ngClass]="
              router.url.split('/').includes('benutzereinstellungen') ? 'active-link' : null
            "
          >
            <mat-icon fontSet="fa" fontIcon="fa-user"></mat-icon>
          </button>
          <mat-menu #benutzerMenu>
            <button
              id="benutzereinstellungen-menu-item"
              mat-menu-item
              [routerLink]="getRouterLinkUrlForCurrentTenant('benutzereinstellungen')"
              routerLinkActive="active-link"
              data-testid="navigationBenutzereinstellungenLink_header"
              [attr.aria-label]="
                'Texte.Navigation.NavigiereZu'
                  | translate: { seitentitel: 'Texte.Navigation.Benutzereinstellungen' | translate }
              "
            >
              <mat-icon fontSet="fa" fontIcon="fa-user-cog" class="nav-menu-item"></mat-icon>&nbsp;
              {{ 'Texte.Navigation.Benutzereinstellungen' | translate }}
            </button>
            <button
              id="abmelden-menu-item"
              data-testid="navigationAbmeldenLink_header"
              mat-menu-item
              (click)="logout()"
            >
              <mat-icon
                fontSet="fas"
                fontIcon="fa-right-from-bracket"
                class="nav-menu-item"
              ></mat-icon>
              {{ 'Texte.Navigation.Abmelden' | translate }}
            </button>
          </mat-menu>
        </li>
      </ul>

      <div class="hide-gt-sm full-width">
        <div class="toggle-navigation">
          <button
            matButton
            type="button"
            class="toggle-button"
            [matMenuTriggerFor]="dropdownnavigation"
            data-testid="navigationToggleButton"
            id="toolbar-toggle-sidenav"
          >
            <mat-icon fontSet="fa" fontIcon="fa-bars" class="fa-2x toggle-button"></mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-menu #dropdownnavigation="matMenu">
    <button
      mat-menu-item
      class="tab-aufgaben"
      [routerLink]="getRouterLinkUrlForCurrentTenant('aufgaben')"
      routerLinkActive="active-link"
      data-testid="navigationAufgabenLink_sidenav"
      [attr.aria-label]="
        'Texte.Navigation.ButtonMitBadge.AufgabenButtonMitAnzahl'
          | translate
            : {
                seitentitel: 'Texte.Navigation.Aufgaben' | translate,
                aufgabenzahl: meineAufgabenCount$ | async,
              }
      "
    >
      <span
        [matBadge]="getBadgeValue(meineAufgabenCount$ | async)"
        [matBadgeHidden]="(meineAufgabenCount$ | async) === 0"
        matBadgeOverlap="false"
      >
        <span>{{ 'Texte.Navigation.Aufgaben' | translate }}</span>
      </span>
    </button>
    <button
      mat-menu-item
      class="tab-workflows"
      [routerLink]="getRouterLinkUrlForCurrentTenant('workflows')"
      routerLinkActive="active-link"
      data-testid="navigationWorkflowsLink_sidenav"
      [attr.aria-label]="
        'Texte.Navigation.ButtonMitBadge.WorkflowButtonMitAnzahl'
          | translate
            : {
                seitentitel: 'Texte.Navigation.Workflows' | translate,
                workflowzahl: workflowCount$ | async,
              }
      "
    >
      <span
        [matBadge]="getBadgeValue(workflowCount$ | async)"
        [matBadgeHidden]="(workflowCount$ | async) === 0"
        matBadgeOverlap="false"
      >
        {{ 'Texte.Navigation.Workflows' | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      class="tab-zusammenarbeit"
      [routerLink]="getRouterLinkUrlForCurrentTenant('zusammenarbeit')"
      routerLinkActive="active-link"
      data-testid="navigationZusammenarbeitLink_sidenav"
      [attr.aria-label]="getZusammenarbeitAriaLabel() | async"
    >
      <span matBadge="!" [matBadgeHidden]="hasVertreter() | async" matBadgeOverlap="false">
        {{ 'Texte.Navigation.Zusammenarbeit' | translate }}
      </span>
    </button>
    @if (tenantService.currentTenant?.id !== 0) {
      @if ((currentUser$ | async)?.isWorkflowErsteller) {
        <button
          mat-menu-item
          class="tab-vorlagen"
          data-testid="navigationVorlagenLink_sidenav"
          [routerLink]="getRouterLinkUrlForCurrentTenant('vorlagen/persoenlich')"
          routerLinkActive="active-link"
          [attr.aria-label]="
            'Texte.Navigation.NavigiereZu'
              | translate: { seitentitel: 'Texte.Navigation.MeineVorlagen' | translate }
          "
        >
          {{ 'Texte.Navigation.MeineVorlagen' | translate }}
        </button>
      }
    }
    @if ((currentUser$ | async)?.isWorkflowErsteller && tenantService.currentTenant?.id !== 0) {
      <button
        mat-menu-item
        class="workflow-erstellen"
        [routerLink]="getRouterLinkUrlForCurrentTenant('new')"
        data-testid="navigationNeuerWorkflowButton_sidenav"
        [attr.aria-label]="
          'Texte.Navigation.NavigiereZu'
            | translate: { seitentitel: 'Texte.Navigation.NeuerWorkflow' | translate }
        "
      >
        <mat-icon class="sidenav-icon" fontSet="fa" fontIcon="fa-plus"></mat-icon>
        {{ 'Texte.Navigation.NeuerWorkflow' | translate }}
      </button>
    }

    @if ((currentUser$ | async)?.isWorkflowAdministrator && tenantService.currentTenant?.id !== 0) {
      <button mat-menu-item [matMenuTriggerFor]="grundeinstellungenmenu">
        <mat-icon fontSet="fa" fontIcon="fa-cogs"></mat-icon
        >{{ 'Texte.Grundeinstellungen.Grundeinstellungen' | translate }}
      </button>
    }
    @if ((currentUser$ | async)?.isSystemAdmin && tenantService.currentTenant?.id === 0) {
      <button
        mat-menu-item
        [routerLink]="getRouterLinkUrlForCurrentTenant('management')"
        routerLinkActive="active-link"
        data-testid="navigationManagementLink_sidenav"
        [attr.aria-label]="
          'Texte.Navigation.NavigiereZu' | translate: { seitentitel: 'Management Tool' }
        "
        title="Management Tool"
      >
        <mat-icon class="sidenav-icon" fontSet="fa" fontIcon="fa-cogs"></mat-icon> Management Tool
      </button>
    }
    <button
      mat-menu-item
      class="tab-benutzereinstellung"
      [routerLink]="getRouterLinkUrlForCurrentTenant('benutzereinstellungen')"
      routerLinkActive="active-link"
      data-testid="navigationBenutzereinstellungenLink_sidenav"
      [attr.aria-label]="
        'Texte.Navigation.NavigiereZu'
          | translate: { seitentitel: 'Texte.Navigation.Benutzereinstellungen' | translate }
      "
    >
      <mat-icon class="sidenav-icon" fontSet="fa" fontIcon="fa-user-cog"></mat-icon>
      {{ 'Texte.Navigation.Benutzereinstellungen' | translate }}
    </button>
    <button
      mat-menu-item
      class="tab-abmelden"
      routerLink=""
      (click)="logout()"
      data-testid="navigationAbmeldenLink_sidenav"
    >
      <mat-icon class="sidenav-icon" fontSet="fas" fontIcon="fa-right-from-bracket"></mat-icon>
      {{ 'Texte.Navigation.Abmelden' | translate }}
    </button>
  </mat-menu>
</div>

<!-- container mit Logo und Tenantname -->
<ng-template #navCompany>
  <span class="display-contents toolbar-brand-image-item">
    <a
      matButton
      tabindex="0"
      data-testid="navigationRootLinkImage"
      class="toolbar-brand-image"
      title="Startseite"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="getRouterLinkUrlForCurrentTenant()"
      [ngStyle]="{ backgroundImage: backgroundUrl }"
    ></a>
  </span>
  @if (erstellerTenants$ | async; as tenants) {
    <div class="tenant-select" [ngClass]="{ 'full-width-for-small-screen': tenants.length === 1 }">
      @if (tenants.length > 1) {
        <mat-select
          class="toolbar"
          #tenantSelect
          [value]="tenantService.currentTenant$ | async"
          (selectionChange)="tenantService.switchTenant($event.value)"
          placeholder="Mandanten auswählen"
          panelClass="panel-tenant-select"
        >
          @if (tenants.length > 4) {
            <div class="tenantFilterContainer">
              <mat-form-field class="full-width">
                <input
                  matInput
                  type="text"
                  (keyup)="filterTenants($event, tenants)"
                  type="text"
                  placeholder="{{ 'Texte.Allgemein.Alle' | translate }}"
                />
              </mat-form-field>
              @if ((filteredTenants$ | async)?.length === 0) {
                <div>Keine Ergebnisse gefunden</div>
              }
            </div>
          }
          @if (showCurrentTenantInOptions(tenants)) {
            <mat-option class="tenant-option" [value]="tenantService.currentTenant$ | async">
              {{ (tenantService.currentTenant$ | async)?.name }}
            </mat-option>
          }
          @for (tenant of filteredTenants$ | async; track trackTenantBy($index, tenant)) {
            <mat-option class="tenant-option" [value]="tenant">
              <div class="tenant-option-content">
                <img
                  class="tenant-logo"
                  [src]="tenant.logo ?? sechseckLogoPath"
                  alt="{{ tenant.name }}"
                />
                <span class="tenant-name allow-break-word">{{ tenant.name }}</span>
              </div>
            </mat-option>
          }
        </mat-select>
      } @else {
        <div class="single-tenant">
          <span class="tenant-name single-tenant">
            {{ (tenantService.currentTenant$ | async)?.name }}
          </span>
        </div>
      }
    </div>
  }
  <mat-divider [vertical]="true" class="hide-sm" />
</ng-template>
<mat-menu #grundeinstellungenmenu="matMenu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      type="button"
      (click)="setRoute('allgemein')"
      data-testid="grundeinstellungenAllgemeineEinstellungen"
    >
      {{ 'Texte.Grundeinstellungen.AllgemeineEinstellungen.Waben.Titel' | translate }}
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setRoute('vorlagen')"
      data-testid="grundeinstellungenButtonVorlagen"
    >
      {{ 'Texte.Grundeinstellungen.Vorlagen.Waben.Titel' | translate }}
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setRoute('vorlagenkonfiguration')"
      data-testid="grundeinstellungenButtonVorlagenkonfiguration"
    >
      {{ 'Texte.Grundeinstellungen.Vorlagenkonfiguration.Waben.Titel' | translate }}
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setRoute('berechtigungen')"
      data-testid="grundeinstellungenButtonBerechtigungen"
    >
      {{ 'Texte.Grundeinstellungen.Berechtigungen.Waben.Titel' | translate }}
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setRoute('formulare')"
      data-testid="grundeinstellungenButtonFormularEinstellungen"
    >
      {{ 'Texte.Grundeinstellungen.Formulare.Waben.Titel' | translate }}
    </button>
    @if ((currentUser$ | async).isSystemAdmin) {
      <button
        mat-menu-item
        type="button"
        (click)="setRoute('mandant')"
        data-testid="grundeinstellungenButtonMandantenEinstellungen"
      >
        {{ 'Texte.Grundeinstellungen.Mandanteneinstellungen.Waben.Titel' | translate }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="setRoute('services')"
        data-testid="grundeinstellungenButtonServiceConnections"
      >
        {{ 'Texte.Grundeinstellungen.ServiceConnections.Waben.Titel' | translate }}
      </button>
    }
  </ng-template>
</mat-menu>
